<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>



<br>
<mat-form-field class="mat-select-width">
  <mat-label>Ad Networks</mat-label>
  <mat-select (selectionChange)="selectEventNetwork($event)" class="dude.mat-select-value" [disabled]="is_running===true">
    <mat-option *ngFor="let dt of network_list" [value]="dt.id">
      {{dt.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
<br>


<ng-container *ngIf="network">


  <div style="margin-top: 20px; margin-left: 20px">
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>
      <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker" [disabled]="is_running===true">
          <input matStartDate placeholder="Start date" (dateChange)="addDateEvent('start', $event)"
                 formControlName="start_date">
          <input matEndDate placeholder="End date" (dateChange)="addDateEvent('end', $event)"
                 formControlName="end_date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <br>

      <div class="flex-container-submit">
      <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_running===true" type="submit">Submit</button>
      <button mat-raised-button type="button" color="primary" *ngIf="is_running" (click)="stopRunning()" style="margin-left: 10px">Cancel</button>
      </div>
    </form>

  </div>

</ng-container>

<ng-container *ngIf="is_data">
  <div style="margin-left: 20px" class="warn-icon-primary">
    <br>
    <label>No data for the selected time period</label>
  </div>

</ng-container>


<br>


<ng-container *ngIf="campaign_name_list.length>0"> <!--  && !is_running -->

  <mat-form-field class="mat-select-width">
    <mat-label>Campaigns</mat-label>
    <mat-select (selectionChange)="selectEventCampaign($event)" class="dude.mat-select-value" [disabled]="is_running===true">
      <mat-option *ngFor="let dt of campaign_name_list" [value]="dt.campaign_id">
        {{dt.campaign_name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</ng-container>

<br>

<ng-container *ngIf="adgroup_name_list.length>0">

  <mat-form-field class="mat-select-width">
    <mat-label>Adgroups</mat-label>
    <mat-select (selectionChange)="selectEventAdgroup($event)" class="dude.mat-select-value">
      <mat-option *ngFor="let dt of adgroup_name_list" [value]="dt.id">
        {{dt.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</ng-container>


<!--CAMPAIGN HIGHCHARTS-->
<ng-container *ngIf="hc_timeseries_list.length>0">
  <div class="flex-container">
    <ng-container *ngFor="let dt of hc_timeseries_list; let i = index">
      <div class="flex-items mod">
        <mat-card class="mat-elevation-z24">
          <highcharts-chart [Highcharts]="Highcharts" [options]="hc_timeseries_list[i].hcOptions"
                            [callbackFunction]="hc_timeseries_list[i].hcCallback" class="flex-item">
          </highcharts-chart>
        </mat-card>
      </div>
    </ng-container>
  </div>
</ng-container>


<!--CAMPAIGN TABLE-->
<!--<ng-container *ngIf="timeseries_list.length>0">-->
  <div [hidden]="timeseries_list.length==0">

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Campaign Table  <mat-icon matTooltip="{{campaign_status === true ? 'ENABLED' : 'PAUSED'}}" *ngIf="campaign_status && this.network=='googleads'" class="any-icon-primary">play_arrow</mat-icon> <mat-icon *ngIf="!campaign_status && this.network=='googleads'">pause</mat-icon>
      </mat-panel-title>
      <!--      <mat-panel-description>-->
      <!--        Type your name and age-->
      <!--        <mat-icon>account_circle</mat-icon>-->
      <!--      </mat-panel-description>-->
    </mat-expansion-panel-header>

    <div style="margin-left: 20px; width: 300px;">
      <br>
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <!--        <mat-card-header>-->
          <!--          Campaigns-->
          <!--        </mat-card-header>-->

          <mat-card-content>


            <div class="mat-elevation-z24">
              <table mat-table [dataSource]="dataSource" matSort>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                  <td mat-cell *matCellDef="let row"> {{row.date}} </td>
                  <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
                </ng-container>

                <!-- Impressions Column -->
                <ng-container matColumnDef="impressions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Impressions</th>
                  <td mat-cell *matCellDef="let row"> {{row.impressions  | number: '1.0-0'}} </td>
                  <td mat-footer-cell *matFooterCellDef> <strong>{{getTotalMetricsCampaign('impressions') | number: '1.0-0' }}</strong> </td>
                </ng-container>

                <!-- Clicks Column -->
                <ng-container matColumnDef="clicks">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Clicks</th>
                  <td mat-cell *matCellDef="let row"> {{row.clicks  | number: '1.0-0'}} </td>
                  <td mat-footer-cell *matFooterCellDef> <strong>{{getTotalMetricsCampaign('clicks') | number: '1.0-0'}}</strong> </td>
                </ng-container>

                <!-- Conversions Column -->
                <ng-container matColumnDef="conversions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="network=='facebook'">Conversions</th>
                  <td mat-cell *matCellDef="let row" [hidden]="network=='facebook'"> {{row.conversions  | number: '1.0-0'}} </td>
                  <td mat-footer-cell [hidden]="network=='facebook'" *matFooterCellDef> <strong>{{getTotalMetricsCampaign('conversions') | number: '1.0-0' }} </strong></td>
                </ng-container>

                <!-- Conversions All Column -->
                <ng-container matColumnDef="conversions_all">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="network=='facebook'">All Conversions</th>
                  <td mat-cell *matCellDef="let row" [hidden]="network=='facebook'"> {{row.conversions_all  | number: '1.0-0'}} </td>
                  <td mat-footer-cell [hidden]="network=='facebook'" *matFooterCellDef> <strong>{{getTotalMetricsCampaign('conversions_all') | number: '1.0-0' }} </strong></td>
                </ng-container>

                <!-- Cost Column -->
                <ng-container matColumnDef="cost">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Spend</th>
                  <td mat-cell *matCellDef="let row"> {{row.cost | currency}} </td>
                  <td mat-footer-cell *matFooterCellDef> <strong>{{getTotalMetricsCampaign('cost') | currency}} </strong> </td>
                </ng-container>

                <!-- Star Column -->
                <ng-container matColumnDef="star" stickyEnd>
                  <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                  <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                    <mat-icon>more_vert</mat-icon>
                  </td>
                  <td mat-footer-cell [hidden]="is_table_column_hidden" *matFooterCellDef>  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row" (click)="getTableRecord(row)"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr>
              </table>

              <mat-paginator [pageSize]="10"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             showFirstLastButtons></mat-paginator>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </mat-expansion-panel>


<!--</ng-container>-->
</div>

<!--<ng-container *ngIf="adgroup_table_list.length>0">-->
  <div [hidden]="adgroup_table_list.length==0">

  <mat-expansion-panel style="margin-bottom: 50px">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Ad Group Table <mat-icon matTooltip="{{adgroup_status === true ? 'ENABLED' : 'PAUSED'}}" *ngIf="adgroup_status && this.network=='googleads'" class="any-icon-primary">play_arrow</mat-icon> <mat-icon *ngIf="!adgroup_status && this.network=='googleads'">pause</mat-icon>
      </mat-panel-title>
<!--      <span> {{selectedSport.key === 'walking' ? 'steps' : 'km'}} </span>-->


      <!--  <mat-panel-description>-->
      <!--    Type your name and age-->
      <!--    <mat-icon>account_circle</mat-icon>-->
      <!--  </mat-panel-description>-->
    </mat-expansion-panel-header>

    <!--ADGROUP TABLE-->
    <div style="margin-left: 20px; width: 300px;">
      <br>
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <div class="mat-elevation-z24">
            <table mat-table [dataSource]="dataSourceAdgroup" matSort>

              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row"> {{row.date}} </td>
                <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
              </ng-container>

              <!-- Impressions Column -->
              <ng-container matColumnDef="impressions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Impressions</th>
                <td mat-cell *matCellDef="let row"> {{row.impressions  | number: '1.0-0'}} </td>
                <td mat-footer-cell *matFooterCellDef> <strong>{{getTotalMetricsAdGroup('impressions') | number: '1.0-0' }}</strong> </td>
              </ng-container>

              <!-- Clicks Column -->
              <ng-container matColumnDef="clicks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Clicks</th>
                <td mat-cell *matCellDef="let row"> {{row.clicks  | number: '1.0-0'}} </td>
                <td mat-footer-cell *matFooterCellDef> <strong>{{getTotalMetricsAdGroup('clicks') | number: '1.0-0'}}</strong> </td>
              </ng-container>

              <!-- Conversions Column -->
              <ng-container matColumnDef="conversions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="network=='facebook'">Conversions</th>
                <td mat-cell *matCellDef="let row" [hidden]="network=='facebook'"> {{row.conversions  | number: '1.0-0'}} </td>
                <td mat-footer-cell [hidden]="network=='facebook'" *matFooterCellDef> <strong>{{getTotalMetricsAdGroup('conversions') | number: '1.0-0' }} </strong></td>
              </ng-container>

              <!-- Conversions All Column -->
              <ng-container matColumnDef="conversions_all">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="network=='facebook'">All Conversions</th>
                <td mat-cell *matCellDef="let row" [hidden]="network=='facebook'"> {{row.conversions_all  | number: '1.0-0'}} </td>
                <td mat-footer-cell [hidden]="network=='facebook'" *matFooterCellDef> <strong>{{getTotalMetricsAdGroup('conversions_all') | number: '1.0-0' }} </strong></td>
              </ng-container>

              <!-- Cost Column -->
              <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Spend</th>
                <td mat-cell *matCellDef="let row"> {{row.cost | currency}} </td>
                <td mat-footer-cell *matFooterCellDef> <strong>{{getTotalMetricsAdGroup('cost') | currency}} </strong> </td>
              </ng-container>

              <!-- Star Column -->
              <ng-container matColumnDef="star" stickyEnd>
                <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                  <mat-icon>more_vert</mat-icon>
                </td>
                <td mat-footer-cell [hidden]="is_table_column_hidden" *matFooterCellDef>  </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsAdgroup"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsAdgroup;" class="element-row" (click)="getTotalMetricsAdGroup(row)"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumnsAdgroup"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
              </tr>



            </table>

            <mat-paginator [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
        </mat-card>
      </div>
    </div>


  </mat-expansion-panel>
<!--</ng-container>-->
  </div>

<br>
<br>
<br>
